<script>
import OrdersApi from "@/services/orders-api";
import Order from "@/components/orderComponent"

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    
    return null;
}

export default {
    components: {
        Order
    },
    props: {
        orderId: {
            type: Number,
            default: 0,
        },

        linesCount: {
            type: Number,
            default: 0,
        },

        submitAgencyName: {
          type: String,
          default: '',
        },

        agencyDbId: {
          type: [String, Number],
          default: null,
        },

        
        hasAgencySelector: {
          type: Boolean,
          default: null,
        },

  },
    mounted(){
    
    this.getCustomerPossibleDeliveryAddresses()
    ///this.getCustomerDeliveryAddresses();
    //this.getDeliveryModes();

    if (!this.isAvnClient) {
      this.selectedDeliveryMode = this.optionsDeliveryModes[0]
      this.selectedPriority = this.optionsPriorities[0];
    }
 
  },

  computed: {

    isAvnClient() {
      return process.env.VUE_APP_CLIENT_NAME === "avn";
    },

    isOptionPrioritiesEnabled() {
      return process.env.VUE_APP_FEATURE_OPTIONS_PRIORITIES === 'true';
    },
          
    envSupplierFullName(){
      return "Par " + process.env.VUE_APP_CLIENT_FULL_NAME
    },

    customerPortalName(){
      return process.env.VUE_APP_CUSTOMER_PORTAL_NAME
    },

      isAddValidationOrderByCustomerEnabled(){
        return  process.env.VUE_APP_FEATURE_VALIDATION_PARTNER_ORDER_BY_CUSTOMER === 'true'
      },
      isOrderPriorityButtonsEnabled(){
        return  process.env.VUE_APP_FEATURE_ORDER_PRIORITY_BUTTONS === 'true'
      },
      role() {
        return this.$cookies.get('userr');
      },
      isPartner() {
         const  isPartner = JSON.parse(getCookie('isPartner')) || [];
        return isPartner
        },

        isMultiAddressSuported(){
          return  process.env.VUE_APP_FEATURE_MULTI_ADDRESS_SUPPORTED === 'true'
        },
        
  },

  data (){
      return{
          optionsDeliveryAddresses: [],
          selectedDeliveryAddress: null,
          optionsDeliveryModes: process.env.VUE_APP_CLIENT_NAME === "avn"
            ? [{ name: "Livraison par Avenir Pharma Gros", value: 0 }, { name: "Récupération par le client", value: 1 }]
            : [{ name: "Livraison par nos soins", value: 0 }, { name: "Livraison par le client", value: 1 }],
          selectedDeliveryMode: null,

          orderMessage: '',
          isSubmittingOrder:false,
          submitAttempted: false,

          optionsPriorities: process.env.VUE_APP_CLIENT_NAME === "avn"
            ? [{ name: "Journalière", value: 1 }, { name: "Commande Urgente", value: 2 }]
            : [{name:"Normale", value:1}, {name:"Commande Urgente", value:2}],
          selectedPriority: null,

          commitment: false ,
      }
  },

  methods:{

    handleRemovePanacheItem(error) {
      this.$emit('removePanacheItem', error)
    },

    handleUpdatePanacheItem(error) {
      this.$emit('updatePanacheItem', error)
    },

    getCustomerPossibleDeliveryAddresses(customerId){
      OrdersApi.getCustomerDeliveryAddresses(customerId).then(
        (result)=>{
          if(result){
            this.optionsDeliveryAddresses=result
            if(this.optionsDeliveryAddresses.length){
              this.selectedDeliveryAddress=this.optionsDeliveryAddresses[0]
            }
          }

        }
      )
    },

    // getDeliveryModes(){
    //   OrdersApi.getDeliveryModes().then(
    //     (result)=>{
    //       if(result){
    //         this.optionsDeliveryModes=result
    //         if(this.optionsDeliveryModes.length){
    //           this.selectedDeliveryMode=this.optionsDeliveryModes[0]
    //         }
    //       }

    //     }
    //   )
    // },
      submitOrder(isUrgent) {

        this.submitAttempted = true;
        if (this.isAvnClient && ((this.isOptionPrioritiesEnabled && !this.isOrderPriorityButtonsEnabled && !this.selectedPriority) || !this.selectedDeliveryMode)) {
          if (this.$snotify) this.$snotify.error("Veuillez sélectionner la priorité de la commande et le moyen de livraison.");
          return;
        }

        if(!this.isOptionPrioritiesEnabled) {
          if (isUrgent) {
            this.selectedPriority = this.optionsPriorities[1];
          } else {
            this.selectedPriority = this.optionsPriorities[0];
          }
        }
        

      this.isSubmittingOrder = true;
      OrdersApi.submitOrder(this.orderId, this.orderMessage, 
      this.selectedPriority==null ? null : this.selectedPriority.value, 
      this.selectedDeliveryAddress==null ? null : this.selectedDeliveryAddress.code,
      false,this.desiredDeliveryDate,this.promotionCode, this.selectedDeliveryMode == null ? null : this.selectedDeliveryMode.value)
      .then(isSubmitted => {
            if(isSubmitted) {
              this.isSubmittingOrder = false;
              this.$emit('update', true)
              this.$root.$emit('order-submitted', true)

              //update cookies
              this.$cookies.remove('drafto');
              this.$cookies.remove('draftoc');
            }
        })
      .finally(() => {
        this.isSubmittingOrder = false; 
      })
    },

  }
}
</script>
<template>
<div class="">
    

  <div class="row p-4 d-print-none order-validate-form">
        <div class="col-12">
          <form class="form-horizontal" role="form">

              <!-- Mode de Livraison -->
            <div  v-if="isMultiAddressSuported && optionsDeliveryAddresses && optionsDeliveryAddresses.length > 0" class="form-group row ">
              <label class="col-md-2 col-form-label text-dark font-size-14">Adresse de livraison</label>
              <div class="col-md-10">
                <v-select class="pb-2 font-size-16"   :options="optionsDeliveryAddresses" v-model="selectedDeliveryAddress" placeholder="Sélectionner un adresse de livraison de la commande" label="address" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select>  
              </div>
            </div>  
            
            <!-- Priorité de la commande -->
            <div class="form-group row " v-if="isOptionPrioritiesEnabled && !isOrderPriorityButtonsEnabled">
              <label class="col-md-2 col-form-label text-dark font-size-14">Priorité de la Commande</label>
              <div class="col-md-10">
                <div v-if="isAvnClient" class="order-radio-group">
                  <b-form-radio
                    v-for="priority in optionsPriorities"
                    :key="priority.value"
                    v-model="selectedPriority"
                    :value="priority"
                    class="custom-radio custom-radio-primary mb-2"
                  >
                    <span :class="selectedPriority === priority ? 'font-weight-bold' : ''">{{ priority.name }}</span>
                  </b-form-radio>
                </div>
                <v-select v-else class="pb-2 font-size-16"  :class="selectedPriority == this.optionsPriorities[1] ? 'font-weight-bold' : ''"   :options="optionsPriorities" v-model="selectedPriority" placeholder="Sélectionner le niveau de priorité de la commande" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 
                <small v-if="isAvnClient && submitAttempted && !selectedPriority" class="text-danger">La priorité de la commande est obligatoire.</small>
              </div>
            </div>  

            <!-- Mode de Livraison -->
            <div class="form-group row ">
              <label class="col-md-2 col-form-label text-dark font-size-14">Moyen de Livraison</label>
              <div class="col-md-10">
                <div v-if="isAvnClient" class="order-radio-group">
                  <b-form-radio
                    v-for="deliveryMode in optionsDeliveryModes"
                    :key="deliveryMode.value"
                    v-model="selectedDeliveryMode"
                    :value="deliveryMode"
                    class="custom-radio custom-radio-primary mb-2"
                  >
                    {{ deliveryMode.name }}
                  </b-form-radio>
                </div>
                <v-select v-else class="pb-2 font-size-16"   :options="optionsDeliveryModes" v-model="selectedDeliveryMode" placeholder="Sélectionner un moyen de livraison de la commande" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select>  
                <small v-if="isAvnClient && submitAttempted && !selectedDeliveryMode" class="text-danger">Le moyen de livraison est obligatoire.</small>
              </div>
            </div>  
                       
            <div class="form-group row mb-0">
              <label class="col-md-2 col-form-label text-dark font-size-14">Ajouter une note à la commande</label>
              <div class="col-md-10">
                  
                <textarea
                    v-model="orderMessage"
                    class="form-control"
                    :maxlength="200"
                    rows="3"
                    :placeholder="$t('ordersDetailsModal.body.message.placeholder')"
                  ></textarea>
                  <div class="text-center">
                    <p
                      v-if="orderMessage"
                      class="badge position-absolute"
                      :class="{ 'badge-success': orderMessage.length !== 200,
                                'badge-danger': orderMessage.length === 200 }"
                    >
                      {{ orderMessage.length }} /
                      200
                    </p>
                  </div>

                  
                  
              </div>
            </div>

           
          </form>
        </div>
      </div>
      
  

      
     
      <!-- <div class="row pb-4 pt-4 mt-4 d-print-none" style="border-top:1px solid gray; ">
        <div class="col-12">
          <form class="form-horizontal" role="form">
           
           <div class="form-group row">
              

              <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
                <label class="font-size-14 text-dark font-weight-bold">Priorité de la commande</label>
                <v-select class="pb-2 font-size-16"   :options="optionsDeliveryModes" v-model="selectedDeliveryMode" placeholder="Sélectionner le niveau de priorité de la commande" label="name" >
                    <span slot="no-options">{{$t("lists.emptyLists.label")}}</span>
                </v-select> 
              </div>

            </div>         
        
        
            <div class="form-group row mb-0" >
              <label class="col-md-12 col-form-label font-size-14 text-dark font-weight-bold">Ajouter une note à la commande</label>
              <div class="col-md-12">
                  
                  <textarea
                    v-model="orderMessage"
                    class="form-control"
                    :maxlength="255"
                    rows="3"
                    :placeholder="$t('ordersDetailsModal.body.message.placeholder')"
                  ></textarea>
                  <div class="text-center">
                    <p
                      v-if="orderMessage"
                      class="badge position-absolute"
                      :class="{ 'badge-success': orderMessage.length !== 255,
                                'badge-danger': orderMessage.length === 255 }"
                    >
                      {{ orderMessage.length }} /
                      255
                    </p>
                  </div>



              </div>
            </div>

          </form>
        </div>
      </div> -->
     
      <div class=" mr-4 ml-4 border border-muted order-validate-sheet">
        <Order  :orderId= this.orderId 
                :isCatalogList=true 
                :deliveryAddress="selectedDeliveryAddress" 
                :deliveryMode="selectedDeliveryMode==null ? null : selectedDeliveryMode.name"
                @removePanacheItem="handleRemovePanacheItem"
                @updatePanacheItem="handleUpdatePanacheItem" /> 

      </div>

      <div class="row mt-4 mr-4 ml-4 d-print-none" >
        <div v-if="linesCount && linesCount > 28" class="col-12 text-right font-weight-bold text-danger">
          <i class="fas fa-exclamation-triangle  mr-1"></i>Votre commande sera divisée en deux ou plusieurs bons de commande.
        </div>
      </div>

      <div class="row mt-4 mr-4e ml-4 d-print-none ">
        <div class="col-lg-6 col-md-12" ></div>
        
        <div class="col-lg-6 col-md-12 text-right pr-3  " v-if="isPartner==true && !isAddValidationOrderByCustomerEnabled">
                    <b-form-checkbox
                        :value=true
                        :unchecked-value=false
                        class="custom-checkbox custom-checkbox-outline custom-checkbox-danger mb-0 mt-0"
                        v-model="commitment"
                        > 
                        <span  class="font-size-16" :class="commitment == true ? 'text-danger' : 'text-muted'" >  Je m’engage que le pharmacien a validé la commande</span>
                    </b-form-checkbox>
        </div>
      </div>

      <div class="row mt-1 mr-4 ml-4 d-print-none" >
          <!-- <div class="col-md-4 col-sm-12 "/-->
          <div class="col-md-6 col-sm-12 "/>
          <div class="col-md-6 col-sm-12 d-print-none pr-0 text-right ">
              <b-button v-if="isOrderPriorityButtonsEnabled" variant="danger" class="m-2"  size="lg" @click="submitOrder(true)" :disabled="isPartner == true ? !commitment || isSubmittingOrder : isSubmittingOrder" >
                  <i class="fas fa-exclamation-triangle font-size-18 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-16"><span class="font-size-14 font-weight-bold text-uppercase">Envoyer commande</span> URGENTE </span>
              </b-button>

              <b-button variant="primary" class="m-2" size="lg" @click="submitOrder(false)" :disabled="isPartner == true && isOrderPriorityButtonsEnabled && !isOptionPrioritiesEnabled  ? !commitment || isSubmittingOrder : isSubmittingOrder" >
                  <i class="fas fa-paper-plane font-size-18 font-weight-bold align-middle mr-2"></i> <span class="font-weight-bold font-size-16"><span class="font-size-14 font-weight-bold text-uppercase">Envoyer commande {{ isOrderPriorityButtonsEnabled ? "ORDINAIRE" : "" }}</span></span>
                  <span v-if="hasAgencySelector && submitAgencyName" class="order-submit-agency">Agence {{ submitAgencyName }}</span>
              </b-button>
          </div>
      </div> 
</div>
</template>

<style>
.order-radio-group { display: flex; flex-wrap: wrap; gap: .5rem 1.5rem; padding-top: .45rem; }
.order-radio-group .custom-control { margin-right: 0; }

/* "Valider la commande" (hosts with modal-class="order-validate-modal"), phones: full-screen dialog and no stacked
   gutters (dialog margin + body padding + form p-4 + card padding left ~290px of a 390px screen for the form) */
@media (max-width: 575.98px) {
  .order-validate-modal .modal-dialog { max-width: none; margin: 0; min-height: 100%; }
  .order-validate-modal .modal-content { min-height: 100vh; border: 0; border-radius: 0; }
  .order-validate-modal .modal-body { padding: .75rem; }
  .order-validate-modal .order-validate-form { padding: 2.75rem 0 .25rem !important; margin: 0; }
  .order-validate-modal .order-validate-form > [class*="col-"] { padding-left: 0; padding-right: 0; }
  .order-validate-modal .form-group.row { margin-left: 0; margin-right: 0; }
  .order-validate-modal .form-group.row > [class*="col-"] { padding-left: 0; padding-right: 0; }
  .order-validate-modal .card-body { padding: .75rem; }
  .order-validate-modal .order-validate-sheet { margin: .75rem 0 0 !important; }
}
.order-submit-agency { display: block; margin-top: .15rem; color: inherit; font-size: 10px; font-weight: 800; line-height: 1.2; text-transform: uppercase; opacity: .9; }
</style>
